import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const SnoozeIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M10.6251 0C10.0017 0 9.50023 0.501562 9.50023 1.125C9.50023 1.74844 10.0017 2.25 10.6251 2.25H13.3951L9.77676 6.38437C9.48617 6.71719 9.41586 7.18594 9.59866 7.58906C9.78145 7.99219 10.1845 8.25 10.6251 8.25H15.8745C16.4979 8.25 16.9994 7.74844 16.9994 7.125C16.9994 6.50156 16.4979 6 15.8745 6H13.1045L16.7229 1.86562C17.0135 1.53281 17.0838 1.06406 16.901 0.660938C16.7182 0.257812 16.3151 0 15.8745 0H10.6251ZM16.6245 10.5C16.0011 10.5 15.4996 11.0016 15.4996 11.625C15.4996 12.2484 16.0011 12.75 16.6245 12.75H19.5726L15.7386 17.6859C15.4761 18.0234 15.4293 18.4828 15.6168 18.8719C15.8042 19.2609 16.1979 19.5047 16.6291 19.5047H21.8739C22.4973 19.5047 22.9988 19.0031 22.9988 18.3797C22.9988 17.7563 22.4973 17.2547 21.8739 17.2547H18.9258L22.7644 12.3187C23.0269 11.9812 23.0738 11.5219 22.8863 11.1328C22.6988 10.7437 22.3051 10.5 21.8739 10.5H16.6245ZM3.12592 10.5C2.50255 10.5 2.00104 11.0016 2.00104 11.625C2.00104 12.2484 2.50255 12.75 3.12592 12.75H9.15339L2.21664 22.2094C1.96823 22.5516 1.93073 23.0062 2.11821 23.3812C2.30569 23.7562 2.70409 24 3.12592 24H11.375C11.9984 24 12.4999 23.4984 12.4999 22.875C12.4999 22.2516 11.9984 21.75 11.375 21.75H5.34755L12.2843 12.2906C12.5327 11.9484 12.5702 11.4937 12.3827 11.1187C12.1952 10.7437 11.7969 10.5 11.375 10.5H3.12592Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default SnoozeIcon
